<template>
    <div id="table-schedule">
        <!-- Таблица с видом table -->
        <vs-table
            noDataText=""
            :data="data.schedule.table"
            v-if="typeView === 'table' && data.schedule.table"
        >
            <!-- Header -->
            <template slot="thead">
                <!-- Время дни -->
                <vs-th>{{ $t("time_days") }}</vs-th>
                <!-- Дни недели -->
                <vs-th v-for="day in data.schedule_days" :key="day.date"
                    >{{ day.week_day }}<br />{{ day.date }}
                </vs-th>
            </template>

            <template slot-scope="{ data }">
                <vs-tr v-for="time in data" :key="time.start">
                    <!-- Время по структуре -->
                    <vs-td>
                        <tr class="text-center">
                            {{ time.name }}
                        </tr>
                        <tr>
                            {{ time.start }} - {{ time.end }}
                        </tr>
                     </vs-td>
                    <!-- Ячейки по дням -->
                    <vs-td
                        v-for="(window, index) in time.windows"
                        :key="window.id + index"
                    >
                        <!-- Рендер событий -->
                        <template v-if="window.lesson.length > 0">
                            <lesson
                                :lesson="lesson"
                                @getSchedule="$emit('getSchedule')"
                                v-for="lesson in window.lesson"
                                :key="lesson.uid + index"
                            />
                        </template>
                    </vs-td>
                </vs-tr>
            </template>
        </vs-table>
        <!-- Рендер таблицы вида list -->
        <template
            v-else-if="
                typeView === 'list' &&
                data.schedule.list &&
                data.schedule.list.length
            "
        >
            <vs-table
                v-for="(day, indexDay) in data.schedule.list"
                :data="day.windows"
                :key="day.date"
                noDataText=""
            >
                <template slot="thead">
                    <vs-th style="float: left;">{{ $t("time_days") }}</vs-th>
                    <vs-th> {{ day.week_day }}<br />{{ day.date }} </vs-th>
                </template>

                <template slot-scope="{ data }">
                    <vs-tr v-for="window in data" :key="window.id + indexDay">
                        <vs-td class="w-1/2">
                            <tr class="text-center">
                                {{ window.name }}
                            </tr>
                            <tr>
                                {{ window.start }} - {{ window.end }}
                            </tr>
                        </vs-td>

                        <vs-td>
                            <template v-if="window.lesson.length > 0">
                                <lesson
                                    :lesson="lesson"
                                    @getSchedule="$emit('getSchedule')"
                                    v-for="(lesson,
                                    indexLesson) in window.lesson"
                                    :key="lesson.uid + indexLesson"
                                />
                            </template>
                        </vs-td>
                    </vs-tr>
                </template>
            </vs-table>
        </template>
    </div>
</template>

<script>
import lesson from "./lesson";
export default {
    props: {
        data: Object,
        typeView: String,
    },
    components: {
        lesson,
    },
};
</script>

<style>
#table-schedule .vs-table--tbody-table {
    min-width: 0px !important;
}
</style>


